module.exports = __webpack_public_path__ + "media/bootstrap-icons/badge-vr-b3f0a531.svg";